import db from "@/plugins/dexie";
import { USER_STORAGE  } from '@/constants/STORAGE'
import apirecebimentoweb from '@/services/api-recebimentoweb';
import geraData from "../geradata";
import moment from "moment-timezone";

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}

export default async function $_enviaAbastecimento() {
  const token = JSON.parse(sessionStorage.getItem('auth:token'));
  let abastecimentos = await db.abastecimentosecagem.toArray();
  abastecimentos = abastecimentos.filter(a => !a.absidnuvem || !a.absdatanuvem);
  const idusuario = await getSessionStorage(USER_STORAGE.useidusuario);
  abastecimentos.forEach((item) => {
          if ((item.absidnuvem)) {
              console.log('put - ', item);
              const payload = {

                id: item.absidnuvem,
                absidaberturalote: item.absidaberturalote,
                absidusuario: idusuario,
                absidsecador: item.absidsecador,
                absidsecagem: item.absidsecagem,
                abssecagem: item.abssecagem,
                absstatus: item.absstatus,
                absdatainicio: item.absdatainicio,
                absdatatermino: item.absdatatermino !== "" ? item.absdatatermino : null,

              }
              apirecebimentoweb.put(`/abastecimentosecagem/${item.absidnuvem}`, payload, {
                  headers: {
                      Authorization: `Bearer ${token.token}`
                  }
              }).then((res) => {
                  const alteracao = (moment.utc(res.data.absdataalteracao).subtract(3, 'hours').format('YYYY-MM-DDTHH:mm:ss'))
                  db.abastecimentosecagem.update(item.id, {
                      absoperador: res.data.absoperador,
                      absidusuario: res.data.absidusuario,
                      absdataalteracao: res.data.absdataalteracao,
                      absdatanuvem: alteracao,
                  });
              });    
          } else {
              console.log('post - ', item);
              const payload = {

                absidaberturalote: item.absidaberturalote,
                absidusuario: idusuario,
                absidsecador: item.absidsecador,
                absidsecagem: item.absidsecagem,
                abssecagem: item.abssecagem,
                absstatus: item.absstatus,
                absdatainicio: item.absdatainicio,
                absdatatermino: item.absdatatermino !== "" ? item.absdatatermino : null,
                absdataalteracao: geraData(),
              }
              apirecebimentoweb.post('/abastecimentosecagem', payload, {
                  headers: {
                      Authorization: `Bearer ${token.token}`
                  }
              }).then((res) => {
                  console.log(res, 'res');
                  const alteracao = (moment.utc(res.data.absdataalteracao).subtract(3, 'hours').format('YYYY-MM-DDTHH:mm:ss'))
                  db.abastecimentosecagem.update(item.id, {
                      absidusuario: res.data.absidusuario,
                      absidnuvem: res.data.id,
                      absoperador: res.data.absoperador,
                      absdataalteracao: res.data.absdataalteracao,
                      absdatanuvem: alteracao,
                  });
              });
          }
  }); 
}

export async function $_deletaAbastecimento() {
  const token = JSON.parse(sessionStorage.getItem('auth:token'));
  let abastecimentos = await db.abastecimentosecagem.toArray();
  abastecimentos = abastecimentos.filter(a => a.absdeletar);
  abastecimentos.forEach((item) => {
    apirecebimentoweb.delete(`/abastecimentosecagem/app/${item.absidnuvem}`, {
      headers: {
          Authorization: `Bearer ${token.token}`
      }
  }).then((res) => {
      console.log(res, 'res');
      db.abastecimentosecagem.where({id: item.id}).delete();
  });
  })
}